import { Button, Result } from 'antd';
import { useEffect, useState } from 'react';
import { t } from 'i18next';

export const DocumentViewer = ({
  url,
  allow = false,
}: {
  url: string;
  allow?: boolean;
}) => {
  const viewerUrl = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
    url,
  )}`;
  const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);
  const [allowExternalPreview, setAllowExternalPreview] = useState(allow);

  useEffect(() => {
    if (allowExternalPreview && iframeRef?.contentWindow) {
      // hack but not always working also
      try {
        iframeRef.contentWindow.location.replace(viewerUrl);
      } catch {
        // cross-origin frame access may fail
      }
    }
  }, [allowExternalPreview, iframeRef, url, viewerUrl]);

  return (
    <>
      {!allowExternalPreview ? (
        <Result
          subTitle={t('useGoogleDrive')}
          extra={
            <Button
              onClick={() => setAllowExternalPreview(true)}
              shape="round"
              size="large"
            >
              {t('allowAccessToViewer')}
            </Button>
          }
        />
      ) : (
        <iframe
          key={url}
          // sometimes not working ..weird
          src={viewerUrl}
          ref={setIframeRef}
          title={t("preview")}
          height={'100%'}
          width={'100%'}
          style={{ border: 0 }}
        />
      )}
    </>
  );
};
